import { render, staticRenderFns } from "./ForwardMessage.vue?vue&type=template&id=f041598a&scoped=true&"
import script from "./ForwardMessage.vue?vue&type=script&lang=js&"
export * from "./ForwardMessage.vue?vue&type=script&lang=js&"
import style0 from "./ForwardMessage.vue?vue&type=style&index=0&id=f041598a&lang=less&scoped=true&"
import style1 from "./ForwardMessage.vue?vue&type=style&index=1&id=f041598a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f041598a",
  null
  
)

export default component.exports